import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import Login from "components/login/Login";
import ForgotPassword from "components/login/ForgotPassword ";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useEagerConnect from "hooks/useEagerConnect";
import Enterdigitcode from "components/login/Enterdigitcode";
import Createnewpassword from "components/login/Createnewpassword";


function App() {
  useEagerConnect();

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path="/adminlogin" render={(props) => <Login {...props} />} />
          {/* Forgot Password Route */}
          <Route
            path="/forgot"
            render={(props) => <ForgotPassword {...props} />}
          />

          <Route
            path="/Createnewpassword"
            render={(props) => <Createnewpassword {...props} />}
          />

          <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
          <Redirect to="/adminlogin/dashboard" />
        </Switch>
      </BrowserRouter>
      <ToastContainer
        autoClose={5000}
        style={{ fontSize: 12, fontWeight: 300 }}
        theme="light"
        position="top-right"
      />
    </>
  );
}

export default App;
